/* eslint-disable react-hooks/exhaustive-deps */
import { useApi } from '@backstage/core-plugin-api';
import { notificationApiRef } from '../../../../apis/notificationApi';
import { ratingsApiRef } from '../../../../apis/ratingsApi';
import { useEffect, useState } from 'react';

export const useGetApms = () => {
  const notificationApi = useApi(notificationApiRef);
  const ratingsApi = useApi(ratingsApiRef);
  const [allApms, setAllApms] = useState<any[]>([]);

  const fetchApms = async () => {
    try {
      const response = await ratingsApi.getApms();
      if ((response as any)?.status === 'SUCCESS') {
        setAllApms((response as any)?.data ?? []);
      } else if (Array.isArray(response)) {
        setAllApms(response);
      }
    } catch (error) {
      notificationApi.sendNotification({
        message: `Error occurred - ${error}`,
        disapperAfterMs: 2500,
        severity: 'error',
      });
    }
  };

  useEffect(() => {
    fetchApms();
  }, []);

  return [allApms];
};
